declare let $2sxc: any;

require('../scss/_styles.scss');

const searchInput: HTMLInputElement = document.querySelector('.teamSearchInput');
const searchBtn: HTMLElement = document.querySelector('.teamSearchBtn');
const departmentSelect: HTMLInputElement = document.querySelector('#categoryMenu');
const staffWrapper: HTMLElement = document.querySelector('.staff-wrapper');
searchInput.addEventListener('keypress', (event) => {
  if (event.which == 13) {
    event.preventDefault();
    filterByUserInput();
  }
})
searchBtn.addEventListener('click', (e) => {
  filterByUserInput();
})

$("#categoryMenu").change(function() {
  filterByDepartment();
})

// getUsers();

function filterByUserInput() {
  const searchVal = searchInput.value.toLowerCase();
  const cleanSearchVal = searchVal.replace(' ', '_');
  hideContent();
  
  $(`[class*="first-${searchVal}"]`).show();
  $(`[class*="first-${searchVal}"]`).show();
  $(`[class*="name-${cleanSearchVal}"]`).show();

  showError();
}

function filterByDepartment() {
  const filterVal = departmentSelect.value.toLowerCase().replace(' ', '_');
  hideContent();

  $(`[class*="department-${filterVal}"]`).show();

  showError();
}

function showError() {
  if($('.staff-content:visible').length == 0) {
    $('.staff-error').show();
  }
}

function hideContent() {
  $('.staff-content').hide();
  $('.staff-error').hide();
}

function getUsers() {
  $2sxc(10232).webApi.get('app/auto/api/Employees/GetEmployees')
    .success((users: any) => {
      const loader: HTMLElement = document.querySelector('.staff-loading');
      const staffContainer: HTMLElement = document.querySelector('.staff-container');
      const pageUrl = staffWrapper.dataset.pageurl;

      loader.style.display = 'none';
      staffContainer.innerHTML = '';
      
      users.forEach((user: any) => {
        const firstName = user.FirstName;
        const lastName = user.LastName;
        const cleanFirstName = firstName.toLowerCase().replace(' ', '_');
        const cleanLastName = lastName.toLowerCase().replace(' ', '_')
        const department = user.Department;
        const cleanDepartment = department.toLowerCase().replace(' ', '_');

        staffContainer.innerHTML = staffContainer.innerHTML + `<div class="staff-content transition department-${cleanDepartment} first-${cleanFirstName} last-${cleanLastName} name-${cleanFirstName}_${cleanLastName} name-${cleanLastName}_${cleanFirstName}">
          <div class="image">
            <img src="${user.Photo}" title="${firstName} ${lastName}">
          </div>
          <div class="name">
            <span>${user.LastName}</span>, <span>${firstName}</span><br>
            <span>${user.Title != null ? user.Title : ""}</span>
          </div>
          <div class="position small">
            <span>${user.Position}</span><br>
            <span>${department}</span>
          </div>
          <a class="email small" href="mailto:${user.Email}"><span>${user.Email}</span></a>
          <span class="phoneNr small">${user.Telephone}</span>
          <a class="details apercu small" title="Acker Marie" href="${pageUrl}/details?user=${user.UserName}">Details
            <span class="arrow_small_right pink"></span>
          </a>
        </div>`
      });
    })
    .error(() => {
      console.log("error")
    });
}




